import {startOfToday} from 'date-fns';
import {
  Button,
  ButtonGroup,
  Form,
  FormButton,
  FormField,
  FormSubmitHandler,
} from 'platform/components';
import {VStack} from 'platform/foundation';

import {useLazyGetDeliveryNoteManualDownloadQuery} from '@dms/api/warehouse';
import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';

import {RequiredTestIdProps, getIsoStringWithoutTimezone, suffixTestId} from 'shared/web';

import {DownloadNewForm, DownloadNewFormSchema} from '../types/DownloadNewForm';

interface DownloadNewProps extends RequiredTestIdProps {
  onSave: () => void;
  onDiscard: () => void;
}

export function DownloadNew(props: DownloadNewProps) {
  const [downloadPdf] = useLazyGetDeliveryNoteManualDownloadQuery();

  const handleSubmit: FormSubmitHandler<DownloadNewForm> = async (data) => {
    await downloadPdf({params: {dateFrom: getIsoStringWithoutTimezone(data.dateFrom)}})
      .unwrap()
      .then(props.onSave)
      .catch(handleApiError);
  };

  const dateFrom = startOfToday();

  const defaultValues: Partial<DownloadNewForm> = {
    dateFrom,
  };

  return (
    <Form<DownloadNewForm>
      defaultValues={defaultValues}
      experimentalZodSchema={DownloadNewFormSchema}
      onSubmit={handleSubmit}
    >
      {(control) => (
        <VStack spacing={4}>
          <FormField
            isRequired
            control={control}
            type="date"
            name="dateFrom"
            label={i18n.t('page.warehouse.labels.downloadDocumentsSinceDay')}
            data-testid={suffixTestId('cancel', props)}
          />
          <ButtonGroup align="right">
            <Button
              data-testid={suffixTestId('cancel', props)}
              variant="secondary"
              onClick={props.onDiscard}
              title={i18n.t('general.actions.discard')}
            />
            <FormButton
              data-testid={suffixTestId('submit', props)}
              control={control}
              type="submit"
              title={i18n.t('general.actions.confirm')}
            />
          </ButtonGroup>
        </VStack>
      )}
    </Form>
  );
}
